<template>
  <DialogLayout class="wx-biz-message-preview"
                title="模板消息内容">
    <AppScrollbar style="height: 100%">
      <div class="preview-main">
        <el-form size="mini"
                 label-width="72px"
                 label-suffix="：">
          <el-form-item label="用户ID">
            <div class="value">{{rowData.openId}}</div>
          </el-form-item>
          <el-form-item label="模板ID">
            <div class="value">{{rowData.priTmplId}}</div>
          </el-form-item>
          <el-form-item label="消息内容">
            <div class="content">{{rowData.content}}</div>
          </el-form-item>
          <el-form-item v-if="rowData.url"
                        label="跳转链接">
            <div class="value">{{rowData.url}}</div>
          </el-form-item>
        </el-form>
      </div>
    </AppScrollbar>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
export default {
  name: 'WxBizMessagePreview',
  components: {
    DialogLayout,
    AppScrollbar
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .wx-biz-message-preview {
    width: 540px;
    max-width: 100%;
    .preview-main {
      padding: 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 5px;
          .el-form-item__label {
            color: #909399;
            font-size: 12px;
            text-align: left;
          }
          .el-form-item__content {
            font-size: 12px;
            .value,
            .content {
              word-break: break-all;
              word-wrap: break-word;
            }
            .content {
              color: #606266;
              line-height: 200%;
              background-color: #fff;
              border-left: 2px solid #909399;
              padding: 6px 12px;
              white-space: pre-wrap;
            }
          }
        }
      }
    }
  }
</style>
